import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from "axios";
import { getToken } from "utils/getToken";

export const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = getToken();
  if (token) {
    config.headers.set("Authorization", `Token ${token}`);
  }
  return config;
});
